import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Modal } from 'bootstrap';
import { AuthService } from 'src/app/auth/auth.service';
import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';

@Component({
	selector: 'app-vehicle-device-cma',
	templateUrl: './vehicle-device-cma.component.html',
	styleUrls: ['./vehicle-device-cma.component.scss'],
})
export class VehicleDeviceCmaComponent implements OnChanges {
	@Input() deviceList: Array<any> = [];
	@Input() vehicleId;
	@Output() deviceChange = new EventEmitter();
	vehicleDevice: Array<cmaVehicleDevice> = [];
	ownersIds: Array<any> = [];
	data: cmaVehicleDevice = {
		id: null,
		vehicle: null,
		device: null,
		dateFrom: null,
		dateTo: null,
		user: null,
	};
	tableRows = [
		{ id: 'device', name: 'Urządzenie' },
		{ id: 'dateFrom', name: 'Data od' },
		{ id: 'dateTo', name: 'Data do' },
	];
	isItemBefore = false;
	isItemAfter = false;
	private questionsetDeleteSubscription;

	constructor(
		private readonly api: Data2Service,
		private readonly date: DateService,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
		private readonly question: QuestionService,
		private readonly auth: AuthService,
	) {}

	ngOnChanges(): void {
		this.loadData();
	}

	private loadData() {
		this.loader.show();
		this.api.get('/cmaVehicleDevice/?vehicle=' + this.vehicleId, (result, error) => {
			this.vehicleDevice = result.data;
			this.loader.hide();
		});
	}
	selectOwner(owner) {
		this.data = this.vehicleDevice.find((obj) => obj.id == owner.id);
		const positionInArray = this.vehicleDevice.indexOf(this.data);
		this.isItemBefore = positionInArray === 0 ? false : true;
		this.isItemAfter = positionInArray === this.vehicleDevice.length - 1 ? false : true;
		new Modal(document.getElementById('vehicleDeviceSet')).show();
	}

	showAdd() {
		this.data = {
			id: null,
			vehicle: this.vehicleId,
			device: null,
			dateFrom: this.date.now().date,
			dateTo: null,
			user: this.auth.getUserId(),
		};
		this.isItemAfter = false;
		this.isItemBefore = this.vehicleDevice.length > 0 ? true : false;
		if (this.isItemBefore) {
			const lastOwner = this.vehicleDevice[this.vehicleDevice.length - 1];
			if (!lastOwner.dateTo) {
				this.infobox.error('Brak daty do');
				return;
			}
			this.data.dateFrom = this.date.addDays(1, lastOwner.dateTo);
		}
		new Modal(document.getElementById('vehicleDeviceSet')).show();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('vehicleDeviceSet'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	submit() {
		if (this.data.dateTo && this.data.dateTo <= this.data.dateFrom) {
			this.infobox.error('Niepoprawny zakres dat');
			return;
		}
		if (this.data.id) {
			this.update();
			return;
		}
		this.add();
	}

	private add() {
		this.api.post('/cmaVehicleDevice/', this.data, (result, error) => {
			this.data.id = result.data;
			this.loadData();
			this.dialogClose();
		});
	}

	private update() {
		if (!this.data.dateTo) {
			this.data.dateTo = null;
		}
		this.api.put('/cmaVehicleDevice/' + this.data.id + '/', this.data, (result, error) => {
			this.loadData();
			this.dialogClose();
		});
	}

	deleteOpen() {
		this.dialogClose();
		this.question.ask('Czy na pewno usunąć?', 'deleteAsk');
		this.questionsetDeleteSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'deleteAsk') {
				return;
			}
			this.questionsetDeleteSubscription.unsubscribe();
			if (!result.result) {
				return;
			}
			this.api.del('/cmaVehicleDevice/' + this.data.id + '/', (result, error) => {
				if (error) {
					return;
				}
				this.loadData();
			});
		});
	}
}
export interface cmaVehicleDevice {
	id: number;
	vehicle: string;
	device: string;
	dateFrom: string;
	dateTo: string;
	user: string;
}
